import { OktaAuth } from '@okta/okta-auth-js';
import environmentConfig from './environment.config';

export interface AuthConfig {
  issuer: string;
  clientId: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
  scopes: string[];
  pkce: boolean;
}

// OKTA Configuration using centralized environment config
export const authConfig: AuthConfig = {
  issuer: environmentConfig.oktaIssuer,
  clientId: environmentConfig.oktaClientId,
  redirectUri: environmentConfig.oktaRedirectUri,
  postLogoutRedirectUri: environmentConfig.oktaPostLogoutRedirectUri,
  scopes: environmentConfig.oktaScopes,
  pkce: true,
};

// Initialize OKTA Auth instance
export const oktaAuth = new OktaAuth({
  issuer: authConfig.issuer,
  clientId: authConfig.clientId,
  redirectUri: authConfig.redirectUri,
  postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
  scopes: authConfig.scopes,
  pkce: authConfig.pkce,
  // Token storage in localStorage (you can change to sessionStorage if needed)
  tokenManager: {
    storage: 'localStorage',
    autoRenew: true,
    autoRemove: true,
    secure: true,
    expireEarlySeconds: 300, // Renew tokens 5 minutes before expiry
  },
  // Services configuration
  services: {
    autoRenew: true,
    autoRemove: true,
  },
  // Additional configuration for better session handling
  transformAuthState: async (oktaAuth, authState) => {
    // Always check for active session if not authenticated locally
    if (!authState.isAuthenticated) {
      try {
        // Check if there's an active session on the server
        const sessionExists = await oktaAuth.session.exists();
        if (sessionExists) {
          // Try to get fresh tokens
          await oktaAuth.token.getWithoutPrompt({
            scopes: authConfig.scopes,
            responseType: ['id_token', 'token'],
          });
          // Re-evaluate auth state
          const freshAuthState = await oktaAuth.authStateManager.getAuthState();
          return freshAuthState || authState;
        }
      } catch (error) {
        console.log('Session check failed:', error);
      }
    }
    return authState;
  },
});